// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.
import creditMemoPayments from './sales-credit-memo-payments.js';

export default [
    {
        path: '/:organisation/receivables/sales-credit-memos',
        component: () =>
            import('@/pages/[organisation]/receivables/sales-credit-memos.vue'),
        name: 'accounts-receivable.sales-credit-memos.search-sales-credit-memos',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.sales-credit-memo.view-sales-credit-memos',
        },

        children: [
            {
                path: ':id/update-sales-credit-memo',
                component: () =>
                    import('@/pages/[organisation]/receivables/sales-credit-memos/[id]/update-sales-credit-memo.vue'),
                name: 'accounts-receivable.sales-credit-memos.update-sales-credit-memo',
                meta: {
                    loginRequired: true,
                    permission: 'sales-credit-memo.edit',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales-credit-memos" */ '@/pages/[organisation]/receivables/sales-credit-memos/sales-credit-memo/[id].vue'),
                name: 'accounts-receivable.sales-credit-memos.view-sales-credit-memo',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales-credit-memo.view-sales-credit-memos',
                },
                children: [
                    {
                        path: 'new-payment',
                        component: () =>
                            import(/* webpackChunkName: "accounts-receivable.sales-credit-memo-payments" */ '@/pages/[organisation]/receivables/sales-credit-memo-payments/sales-credit-memo-payment/new.vue'),
                        name: 'accounts-receivable.sales-credit-memo-payments.create-sales-credit-memo-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.receivables.sales-credit-memo.create-sales-credit-memo-payment',
                        },
                    },
                ],
            },
            ...creditMemoPayments,
        ],
    },
];
